import { render, staticRenderFns } from "./IntegrationsDetails.vue?vue&type=template&id=2527bb76&scoped=true&"
import script from "./IntegrationsDetails.vue?vue&type=script&lang=js&"
export * from "./IntegrationsDetails.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsDetails.vue?vue&type=style&index=0&id=2527bb76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527bb76",
  null
  
)

export default component.exports